
export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <img 
              src="https://static.readdy.ai/image/31babc308b349a6cc45afd813037d21e/d354bcd0728c30ce902d1dd68b4210ae.png" 
              alt="BIGBATTERY EUROPE" 
              className="h-10 w-auto mb-4"
            />
            <p className="text-sm text-slate-400 leading-relaxed">
              Fabricante europeo de soluciones de energía crítica certificadas CE para infraestructura global
            </p>
          </div>

          <div>
            <h4 className="text-base font-bold mb-4">Productos</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><a href="#products" className="hover:text-white transition-colors">Energía Crítica (UPS)</a></li>
              <li><a href="#products" className="hover:text-white transition-colors">Industrial</a></li>
              <li><a href="#products" className="hover:text-white transition-colors">Almacenamiento</a></li>
              <li><a href="#catalog" className="hover:text-white transition-colors">Catálogo</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-bold mb-4">Empresa</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><a href="#about" className="hover:text-white transition-colors">Sobre Nosotros</a></li>
              <li><a href="#certifications" className="hover:text-white transition-colors">Certificaciones</a></li>
              <li><a href="#contact" className="hover:text-white transition-colors">Contacto</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-bold mb-4">Contacto</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>ventas@bigbattery.co</li>
              <li>+34 936 25 81 48</li>
              <li>Calle riu de l'or, 39</li>
              <li>08034, Barcelona, España</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-sm text-slate-400">
              © 2025 BIGBATTERY EUROPE SL. NIF: B67614271. Todos los derechos reservados.
            </div>
            <div className="text-sm text-slate-400">
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
